import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Regex } from '@app/shared/enums/regex';

export function eidValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;

    if (!value) {
      return null;
    }

    if (!RegExp(Regex.EID).test(value)) {
      return { eidError: true };
    }

    try {
      const big = BigInt(value);
      // Following same checksum logic as in EID value object in IOS
      return big % 97n === 1n ? null : { eidError: true };
    } catch {
      return { eidError: true };
    }
  };
}
